import React from 'react';
import { SEARCH } from "../../../constants/perspectives";
import { resolveNewPerspectiveFromTransitionFilters } from "../../../utils/transitions";
import FiltersLink from "./FiltersLink";
const DiscoverFiltersLink = props => {
  const newPerspective = resolveNewPerspectiveFromTransitionFilters(props.newFilters);
  let href;
  if (newPerspective === SEARCH) {
    href = props.filtersContext.get('searchFacetHrefResolver') ? props.filtersContext.get('searchFacetHrefResolver')({
      filters: props.newFilters
    }) : '#';
  } else {
    href = props.filtersContext.get('discoverFacetHrefResolver') ? props.filtersContext.get('discoverFacetHrefResolver')({
      filters: props.newFilters
    }) : '#';
  }
  return /*#__PURE__*/React.createElement(FiltersLink, {
    className: props.className,
    href: href,
    onClick: props.onClick,
    newFilters: props.newFilters,
    newPerspective: newPerspective,
    tabIndex: props.tabIndex
  }, props.children);
};
export default DiscoverFiltersLink;